import React, { useState, useEffect } from "react";
import "../App.css";
import { Helmet } from "react-helmet";
import banner from "../assets/about-banner.webp"; // apni image daal do

const TermsConditions = () => {
  return (
    <section className="terms-premium-page">
      <Helmet>
        <link
    rel="canonical"
    href="https://slimlinehardwarefittings.com/terms-conditions"
  />
  <title>Terms and Conditions | Slimline Hardware</title>
  <meta name="description" content="Terms and conditions for using Slimline Hardware website and services." />
</Helmet>
      {/* ===== HERO ===== */}
      <div className="terms-premium-hero">
        <div className="terms-premium-hero-inner">
          <h1>Terms & Conditions</h1>
          <p>Clear rules for using our website and services</p>
        </div>
      </div>

      {/* ===== CONTENT ===== */}
      <div className="terms-premium-container">
        <div className="terms-premium-cards">
          <div className="terms-premium-card">
            <span className="step">01</span>
            <h2>Acceptance of Terms</h2>
            <p>
              By using this website, you agree to follow these Terms & Conditions
              and all applicable laws and regulations.
            </p>
          </div>

          <div className="terms-premium-card">
            <span className="step">02</span>
            <h2>Website Usage</h2>
            <p>
              You must not misuse the website, attempt unauthorized access, or
              use the content for illegal purposes.
            </p>
          </div>

          <div className="terms-premium-card">
            <span className="step">03</span>
            <h2>Product Information</h2>
            <p>
              Product images and descriptions are for reference only and may
              slightly differ from actual products.
            </p>
          </div>

          <div className="terms-premium-card">
            <span className="step">04</span>
            <h2>Pricing & Availability</h2>
            <p>
              Prices and availability may change without prior notice.
            </p>
          </div>

          <div className="terms-premium-card">
            <span className="step">05</span>
            <h2>Limitation of Liability</h2>
            <p>
              We are not responsible for any damages arising from the use of our
              website or products.
            </p>
          </div>

          <div className="terms-premium-card contact">
            <h2>Need Help?</h2>
            <p>
              For any questions, email us at{" "}
              <a href="mailto:support@yourwebsite.com" className="terms-email">
                info@slimlinekitchens.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TermsConditions;